import React, { useState, useEffect, useContext } from "react";
// @material-ui/core components
import { makeStyles, Typography, Button, CircularProgress } from "@material-ui/core";
import MuiAlert from '@material-ui/lab/Alert';
// core components
import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";
import Table from "components/Table/Table.js";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardBody from "components/Card/CardBody.js";
import RecordsMenu from "components/Menus/RecordsMenu.js";
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import CustomSnackbar from "components/Snackbar/CustomSnackbar.js";
import SearchIcon from '@material-ui/icons/Search';
// data imports
import db from 'firebase/dbConfig'
import { atualizarGrupo } from 'firebase/firestoreData'
// Context
import { UserContext } from 'context/userContext'
import { Link } from 'react-router-dom'

const useStyles = makeStyles(theme => ({
  cardCategoryWhite: {
    "&,& a,& a:hover,& a:focus": {
      color: "rgba(255,255,255,.62)",
      margin: "0",
      fontSize: "14px",
      marginTop: "0",
      marginBottom: "0"
    },
    "& a,& a:hover,& a:focus": {
      color: "#FFFFFF"
    }
  },
  cardTitleWhite: {
    color: "#FFFFFF",
    marginTop: "0px",
    minHeight: "auto",
    fontWeight: "300",
    fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    marginBottom: "3px",
    textDecoration: "none",
    "& small": {
      color: "#777",
      fontSize: "65%",
      fontWeight: "400",
      lineHeight: "1"
    }
  },
  card:{
    background: 'white',
    [theme.breakpoints.down("xs")]: {
      minWidth: '95vw',
      position: 'relative',
      right: 20,
      padding: '-15px',
    },
  },
  alert: {
    margin: 20,
    textAlign: 'justify',
  },
  icons:{
    "&:hover": {
      background: 'rgb(230, 230, 230)',
      cursor: 'pointer',
    }
  },
  linkBox:{
    marginTop: 30,
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
  },
  infoIcon: {
    marginRight: 20,
  },
  progress:{
    margin: 50,
  },
  headText:{
    color: 'black',
    margin: '0 20px 10px 20px',
    fontSize: '0.9rem',
    fontWeight: 500,
    marginBottom: '20px',
  },
  permissionBtn:{
    marginLeft: 10,
    marginRight: '-10px',
  },
  formControl:{
    width: 170,
    maxWidth: 170,
    marginTop: '-15px',
    [theme.breakpoints.down("md")]: {
      marginLeft: 15,
    },
  },
}))

const LIMIT = 50

export default function GroupPage() {
  const classes = useStyles()
  const [fichas, setFichas] = useState([])
  const [lastVisible, setLastVisible] = useState([])
  const [displayOrder, setDisplayOrder] = useState("data (mais recentes)")
  const [dateOrder, setDateOrder] = useState(["ANTIGAS"])
  const [nameOrder, setNameOrder] = useState(["A => Z"])
  const [disableNextButton, setDisableNextButton] = useState(false)
  const [showErrorMessage, setShowErrorMessage] = useState(false)
  let tabledData = []
  const {currentUser, userProfile, groupName, groups} = useContext(UserContext)


  useEffect(() => {
    if (groupName){
      db.collection('fichas').where('groupName', '==', groupName).orderBy("data", "desc").limit(LIMIT)
      .onSnapshot(snapshot => {
        const length = snapshot.docs.length
        setLastVisible(snapshot.docs[length - 1])
        setDisableNextButton(false)

        const allRecords = snapshot.docs.map(doc => ({
          id: doc.id,
          ...doc.data()
        }));

        setFichas(allRecords);
      });
     }
   }, [currentUser, groupName]);

    function handleNextPage(){
      db.collection('fichas').where('groupName', '==', groupName).orderBy("data", "desc").startAfter(lastVisible).limit(LIMIT)
      .onSnapshot(snapshot => {
        const length = snapshot.docs.length
        if (snapshot.docs[length - 1]){
          setLastVisible(snapshot.docs[length - 1])
        } else {
          setDisableNextButton(true)
        }
        const allRecords = snapshot.docs.map(doc => ({
          id: doc.id,
          ...doc.data()
        }));
        setFichas(prev => [...prev, ...allRecords]);
      });
    }

    function handleGroupChange(groupNamePicked) {
      const groupPicked = groups.filter(group => group.id === groupNamePicked)
      if (groupPicked && groupPicked[0].members.includes(currentUser.email)){
        atualizarGrupo(currentUser.uid, groupNamePicked)
      }
      else {
        setShowErrorMessage(true)
      }
    }

    fichas.map(ficha => (
      tabledData.push(
        [ficha.data.toDate().toLocaleDateString(),
         ficha.nome,
         ficha.idade,
         <RecordsMenu ficha={ficha}/>
       ])
    ))

    const container =  <>
                          <GridContainer>
                            <GridItem xs={12} sm={12} md={12}>
                              <Card className={classes.card}>
                                <CardHeader color="primary">
                                  <h4 className={classes.cardTitleWhite}>APAs do Grupo</h4>
                                  <p className={classes.cardCategoryWhite}>
                                    Exibindo os últimos atendimentos do grupo
                                  </p>
                                </CardHeader>
                                <CardBody>
                                  {fichas.length === 0 && <><MuiAlert className={classes.alert}
                                                                    elevation={6}
                                                                    variant="filled"
                                                                    severity="info">
                                                <span className={classes.infoIcon}>ⓘ </span> Carregando
                                                informações do banco de dados... Caso elas demorem ou
                                                não apareçam: Verifique sua conexão e/ou se certifique que
                                                você já salvou alguma ficha
                                                          </MuiAlert>
                                                          <CircularProgress className={classes.progress}/>
                                                          </>}

                                  <div className={classes.linkBox}>
                                    <SearchIcon/>
                                    <Link to='/groupsearch'>
                                      <Typography variant="caption">Pesquisar pacientes por nome</Typography>
                                    </Link>
                                  </div>
                                  <Table
                                    tableHeaderColor="primary"
                                    tableHead={["Data", "Nome", "Idade", "Opções"]}
                                    tableData={tabledData}
                                  />
                                </CardBody>
                              </Card>
                            </GridItem>
                            <Button disabled={disableNextButton} variant="outlined" style={{margin: '0 auto'}} color="primary" onClick={() => {handleNextPage()}}>VISUALIZAR PRÓXIMOS DA LISTA</Button>
                          </GridContainer>
                        </>

  return (
    <div className={classes.root}>
      { !userProfile &&  ( <MuiAlert className={classes.alert} elevation={6} variant="filled" severity="info">
                      É muito importante que seu perfil seja preenchido! Clique no item "Perfil" no menu lateral.
                    </MuiAlert>
      )}
      { !groupName ? <>
                      <p className={classes.headText}>Buscando informações do grupo...</p>
                      <FormControl className={classes.formControl}>
                        <InputLabel>Escolha o Grupo</InputLabel>
                        <Select defaultValue="" onChange={(e) => {handleGroupChange(e.target.value)}}>
                          {groups.map((grupo, index) => (
                               <MenuItem key={index+grupo.id} value={grupo.id}>{grupo.id}</MenuItem>
                         ))}
                        </Select>
                      </FormControl>
                      <span className={classes.headText}>Caso você ainda não participe e deseja entrar em algum grupo </span>
                     </>
                   :
                    <><p className={classes.headText}>Você faz parte do grupo: {groupName}. Os atendimentos
                    de todos os membros do grupo são compartilhados nessa seção.</p>
                    {container}
                    </>
      }
      <CustomSnackbar open={showErrorMessage} onClose={()=>{setShowErrorMessage(false)}} type={"error"} message={"Você não está autorizado a entrar nesse grupo. Em caso de dúvida, contate o administrador do grupo."}/>
    </div>
  );
}
